import React from 'react';
import { Card, Typography, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';

const { Title, Text } = Typography;
const TimingsWrapperCard = styled(Card)`
	border-radius: 8px;
	margin-bottom: 16px;
	border: 1px solid #f0f0f0;
`;

const CardHeader = styled.div`
	padding: 16px 24px;
	border-bottom: 1px solid #f0f0f0;
`;

const CardTitle = styled(Title)`
	&& {
		margin: 0;
	}
`;

const CardBody = styled.div`
	padding: 24px;
`;

const LabelText = styled(Text)`
	&& {
		font-size: 13px;
	}
`;

const SpacedRow = styled(Row)`
	margin-bottom: 16px;
`;

function TimingsCard({ timings }) {
	return (
		<TimingsWrapperCard bodyStyle={{ padding: '0px' }}>
			<CardHeader>
				<CardTitle level={5}>Timings</CardTitle>
			</CardHeader>

			<CardBody>
				<SpacedRow justify="space-between">
					<Col>
						<LabelText type="secondary">Actual Start Date & Time</LabelText>
					</Col>
					<Col>
						<Text strong>
							{timings?.actual_start_time
								? moment(timings.actual_start_time)
										.add(5, 'hours')
										.add(30, 'minutes')
										.format('DD/MM/YYYY hh:mm:ss A')
								: '-'}
						</Text>
					</Col>
				</SpacedRow>

				<SpacedRow justify="space-between">
					<Col>
						<LabelText type="secondary">Actual End & Time</LabelText>
					</Col>
					<Col>
						<Text strong>
							{timings?.actual_end_time
								? moment(timings.actual_end_time)
										.add(5, 'hours')
										.add(30, 'minutes')
										.format('DD/MM/YYYY hh:mm:ss A')
								: '-'}
						</Text>
					</Col>
				</SpacedRow>

				<Row justify="space-between">
					<Col>
						<LabelText type="secondary">Total Duration of Trip</LabelText>
					</Col>
					<Col>
						<Text strong>{timings?.total_duration_hrs || '-'}</Text>
					</Col>
				</Row>
			</CardBody>
		</TimingsWrapperCard>
	);
}

TimingsCard.propTypes = {
	timings: PropTypes.object,
};

export default TimingsCard;
